import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { APP_BASE_PATH } from '../../_lib/festival'
import { FestivalLoading } from '../FestivalContext/FestivalLoading'

// Alles außerhalb der öffentlichen Seiten gehört zur App unter /app
export const RedirectToApp = () => {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    const target = pathname === '/' ? '' : pathname.replace(/\/$/, '')
    window.location.replace(`${APP_BASE_PATH}${target}${search}${hash}`)
  }, [hash, pathname, search])

  return (
    <FestivalLoading />
  )
}
